import PropTypes from 'prop-types';
import React from 'react';
import { Alert } from 'antd';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      errorInfo,
    });
  }

  render() {
    const { children } = this.props;
    const { errorInfo } = this.state;

    if (errorInfo) {
      return (
        <div>
          <Alert
            message="Error"
            description="Error contact support for help"
            type="error"
            showIcon
          />
        </div>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
